'use client';

import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { useEntities } from '@/lib/hooks/useEntities';
import { EntityCard } from '@/components/EntityCard';
import type { EntitiesQuery } from '@/lib/api/types';
interface ThemeEntitiesProps {
  /** Section heading */
  title: string;
  /** Section subtitle */
  subtitle?: string;
  /** Filter entities by tags */
  tags?: string[];
  /** Filter entities by roles */
  roles?: string[];
  /** Filter entities by type */
  type?: string[];
  /** Filter entities by themes */
  themes?: string[];
  /** Max number of providers to show */
  limit?: number;
}
export function ThemeEntities(t0) {
  const $ = _c(35);
  const {
    title,
    subtitle,
    tags,
    roles,
    type,
    themes,
    limit: t1
  } = t0;
  const limit = t1 === undefined ? 8 : t1;
  let t2;
  if ($[0] !== limit || $[1] !== roles || $[2] !== tags || $[3] !== themes || $[4] !== type) {
    t2 = {
      status: "active",
      tags,
      roles,
      type,
      themes,
      limit,
      context: "theme-entities-featured"
    };
    $[0] = limit;
    $[1] = roles;
    $[2] = tags;
    $[3] = themes;
    $[4] = type;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const query = t2;
  const {
    data,
    isLoading
  } = useEntities(query);
  let t3;
  bb0: {
    if (!data?.pages) {
      let t4;
      if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = [];
        $[6] = t4;
      } else {
        t4 = $[6];
      }
      t3 = t4;
      break bb0;
    }
    let t4;
    if ($[7] !== data.pages || $[8] !== limit) {
      t4 = data.pages.flatMap(_temp).slice(0, limit);
      $[7] = data.pages;
      $[8] = limit;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    t3 = t4;
  }
  const entities = t3;
  if (isLoading) {
    let t4;
    if ($[10] !== title) {
      t4 = <h3 className="text-2xl sm:text-3xl font-bold text-gray-900">{title}</h3>;
      $[10] = title;
      $[11] = t4;
    } else {
      t4 = $[11];
    }
    let t5;
    if ($[12] !== subtitle) {
      t5 = subtitle && <p className="mt-2 text-gray-600">{subtitle}</p>;
      $[12] = subtitle;
      $[13] = t5;
    } else {
      t5 = $[13];
    }
    let t6;
    if ($[14] !== t4 || $[15] !== t5) {
      t6 = <div className="mb-8">{t4}{t5}</div>;
      $[14] = t4;
      $[15] = t5;
      $[16] = t6;
    } else {
      t6 = $[16];
    }
    let t7;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6">{[...Array(4)].map(_temp2)}</div>;
      $[17] = t7;
    } else {
      t7 = $[17];
    }
    let t8;
    if ($[18] !== t6 || $[19] !== t7) {
      t8 = <section className="py-12 sm:py-16 bg-gray-50"><div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">{t6}{t7}</div></section>;
      $[18] = t6;
      $[19] = t7;
      $[20] = t8;
    } else {
      t8 = $[20];
    }
    return t8;
  }
  let t4;
  if ($[21] !== title) {
    t4 = <h3 className="text-2xl sm:text-3xl font-bold text-gray-900">{title}</h3>;
    $[21] = title;
    $[22] = t4;
  } else {
    t4 = $[22];
  }
  let t5;
  if ($[23] !== subtitle) {
    t5 = subtitle && <p className="mt-2 text-gray-600">{subtitle}</p>;
    $[23] = subtitle;
    $[24] = t5;
  } else {
    t5 = $[24];
  }
  let t6;
  if ($[25] !== t4 || $[26] !== t5) {
    t6 = <div className="mb-8">{t4}{t5}</div>;
    $[25] = t4;
    $[26] = t5;
    $[27] = t6;
  } else {
    t6 = $[27];
  }
  let t7;
  if ($[28] !== entities) {
    t7 = entities.map(_temp3);
    $[28] = entities;
    $[29] = t7;
  } else {
    t7 = $[29];
  }
  let t8;
  if ($[30] !== t7) {
    t8 = <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6">{t7}</div>;
    $[30] = t7;
    $[31] = t8;
  } else {
    t8 = $[31];
  }
  let t9;
  if ($[32] !== t6 || $[33] !== t8) {
    t9 = <section className="py-12 sm:py-16 bg-gray-50"><div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">{t6}{t8}</div></section>;
    $[32] = t6;
    $[33] = t8;
    $[34] = t9;
  } else {
    t9 = $[34];
  }
  return t9;
}
function _temp3(entity) {
  return <EntityCard key={entity.id} entity={entity} entityType={entity.type} variant="compact" />;
}
function _temp2(_, i) {
  return <div key={i} className="animate-pulse bg-white rounded-2xl overflow-hidden shadow-sm"><div className="h-[200px] bg-gray-200" /><div className="p-4"><div className="h-4 bg-gray-200 rounded w-3/4 mb-2" /><div className="h-3 bg-gray-200 rounded w-1/2" /></div></div>;
}
function _temp(page) {
  return page.entities;
}